import { Component } from "react";
import { CriticalAlert } from "../components/Annoucements/CriticalAlert";
import WithAuth from "../components/Auth/WithAuth";
import PellerexNotifications from "../components/Notification/PellerexNotifications";
import { Footer } from "../screens/Website/Common/Footer";
import MarketingNavBar from "../screens/Website/Common/MarketingNavBar";
import WebsiteRouter from "./WebsiteRouter";
import { clearTheme } from "../common/theme";

class Landing extends Component {
  componentDidMount() {
    // The marketing site is light-only; never inherit the dashboard's dark class.
    clearTheme();
  }

  render() {
    return (
      <div className="flex flex-col">
        {/* <CriticalAlert
          title="Major Upgrade"
          text="We are deploying major improvements and frontend services might be impacted. All backend service work as usual. If you face any issues, contact support."
        /> */}
        <MarketingNavBar />
        {/* <NewMarketingNavBar /> */}
        <WebsiteRouter />
        <PellerexNotifications />
        <Footer />
      </div>
    );
  }
}

export default WithAuth(Landing);
